module.exports = __webpack_public_path__ + "img/resourceful.5270d15c.png";